import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SignaturePanel } from './signaturePanel';
import { SIGNATURE_ACTION_TYPE } from './constants';
import { FindSuccessItem, formatAMPMNeW, useModal } from 'utils';
import { httpRequestsOnSuccessActions } from 'store';
import moment from 'moment';

const SUCCESS_TYPE = SIGNATURE_ACTION_TYPE;

export const tabEnums = {
    DRAW: 'Draw',
    TYPE: 'Type',
};
export const SignatureUploader = ({afterSuccess}) => {
    const { appt } = useSelector((state) => ({
        appt: state.appointment.appointmentById,
    }));
    const dispatch = useDispatch();
    const success = FindSuccessItem(SUCCESS_TYPE);
    const { close } = useModal();

    useEffect(() => {
        if (success?.type === SUCCESS_TYPE) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(SUCCESS_TYPE));
            close();
            if(afterSuccess){
                afterSuccess()
            }
        }
    }, [success]);

    return (
        <div className="signature-tabs-wrapper">
            <p className="modal-header-title" style={{ textAlign: 'start' }}>
                Signatures
            </p>
            <div className="signature-modal-info-box">
                <div className="appt-detail-box">
                    <p className="appt-detail-modal-title">Appt ID:</p>
                    <p className="appt-detail-modal-value">{appt?.displayId}</p>
                </div>
                <div className="appt-detail-box">
                    <p className="appt-detail-modal-title">Date/Time:</p>
                    <p className="appt-detail-modal-value">
                        <div className="flex-align-center" style={{ gap: '8px' }}>
                            <p>{moment.utc(appt?.startDate).format('MM/DD/YYYY')}</p>
                            <p className="schedule-time">{`${formatAMPMNeW(appt?.startTime)} - ${formatAMPMNeW(appt?.endTime)}`}</p>
                        </div>
                    </p>
                </div>
                <div className="appt-detail-box">
                    <p className="appt-detail-modal-title">CPT Code: </p>
                    <p className="appt-detail-modal-value">{appt?.authorizedService?.service?.cptCode}</p>
                </div>
            </div>

            <div className="modal-body-wrapper space-between" style={{ alignItems: 'flex-start', margin: 0, padding: '0 0 16px' }}>
                <div className="signature-tab-box">
                    <SignaturePanel
                        appt={appt}
                        provider={false}
                        title="Client/Guardian Signature"
                        showGuardianSelector={true}
                        hideSaveDefault={true}
                        // showSavedSignature
                        guardianWidth={'100%'}
                        showFooter
                        submitLabel="Submit"
                    />
                </div>
                <div className="signature-tab-box">
                    <SignaturePanel
                        showSavedSignature
                        appt={appt}
                        provider={true}
                        title="Provider Signature"
                        showFooter
                        submitLabel="Submit"
                    />
                </div>
            </div>
        </div>
    );
};
